module.exports = __webpack_public_path__ + "static/media/M72ws.3c9b74ca.pdf";